import React from 'react';
import QuizSettingsEditor from '../../quizes/components/QuizSettingsEditor';

/**
 * QuizSettingsPanel - Panel for editing quiz settings in the course editor
 * Uses the shared QuizSettingsEditor component in panel mode
 *
 * @param {Object} props
 * @param {Object} props.quizSettings - Current quiz settings
 * @param {string} props.quizName - Quiz name (from section/page)
 * @param {Function} props.onSave - Callback when settings are saved
 * @param {Function} props.onClose - Callback when panel closes
 * @returns {JSX.Element}
 */
const QuizSettingsPanel = ({ quizSettings, quizName, onSave, onClose }) => {
  return (
    <QuizSettingsEditor
      quizSettings={quizSettings}
      quizName={quizName}
      onSave={onSave}
      onClose={onClose}
      variant="panel"
    />
  );
};

export default QuizSettingsPanel;
